import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";
import { FaUserCircle } from "react-icons/fa";
import { toast } from "react-toastify"; // Removed ToastContainer (usually in App.js, but kept if you need it here)
import "react-toastify/dist/ReactToastify.css";
import { FaArrowLeft } from "react-icons/fa";
// Assets
import logo from "../asset/logowhite.png";
import loginbg from "../asset/login/studentlogin.png";
import SummaryApi from "../common";
import { useAuth } from "../helpers/AuthContext";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const StudentLogin = () => {
  const navigate = useNavigate();
  // Get studentId and sessionToken from AuthContext
  const { login, logout, studentId, sessionToken } = useAuth();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    identifier: "",
    password: "",
  });

  // --- Session Verification useEffect ---
  useEffect(() => {
    const verifyStudentSession = async () => {
      const storedStudentId = sessionStorage.getItem("student_id");
      const storedStudentEmail = sessionStorage.getItem("student_email");
      const storedSessionToken = sessionStorage.getItem("H7Z4L9VD2XK5JW8QRYT6");

      if (!storedStudentId || !storedStudentEmail || !storedSessionToken) {
        return;
      }

      setIsLoading(true); 
      try {
        if (storedStudentId && storedSessionToken) {
            toast.info("Welcome back!");
            navigate("/student-panel/student-dashboard", { replace: true });
        } else {
            logout(); 
        }

      } catch (error) {
        console.error("Student session verification error:", error);
        toast.error("Error verifying session. Please log in again.");
        logout(); 
      } finally {
        setIsLoading(false);
      }
    };

    if (!studentId && !sessionToken) {
      verifyStudentSession();
    }
  }, [navigate, studentId, sessionToken, logout]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // --- 1. ADD THIS FUNCTION (Same as StudentCreate) ---
  const sendSmsOtp = async (mobileNumber, otpValue) => {
    // Construct the URL with the provided details
    const smsUrl = `https://sms.nettyfish.com/api/v2/SendSMS?SenderId=OAKYA&TemplateId=1707173313269381321&Message=Dear%20User%20your%20OTP%20${otpValue}%20for%20accessing%20admin%20panel%20-Oakya&PrincipleEntityId=1701172795416066262&ApiKey=ktTxImpILf3IA3lAdLt3sxLwpf0GUx41h9y%2BhU1LaWU=&ClientId=12eae6c0-7738-4f2a-afbe-77888ae20d0f&MobileNumbers=${mobileNumber}`;

    try {
        await fetch(smsUrl, {
            method: 'GET',
            mode: 'no-cors', // Required for browser calls to SMS gateways
        });
        console.log('SMS Request Sent');
        return true;
    } catch (error) {
        console.error("SMS Error", error);
        return false;
    }
  };

 const handleSubmit = async (e) => {
    e.preventDefault();
    const { identifier, password } = formData;

    if (!identifier || !password) {
      toast.error("Please fill in all fields");
      return;
    }

    // Check what the user entered
    const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identifier);
    const isMobile = /^\d{10}$/.test(identifier);

    if (!isEmail && !isMobile) {
      toast.error("Please enter a valid email or mobile number");
      return;
    }

    const payload = {
      password,
      ...(isEmail ? { email: identifier } : { mobile_number: identifier }),
    };

    setIsLoading(true);
    try {
      const res = await fetch(SummaryApi.studentLogin.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      console.log("Login Response:", data);

      if (data.status) {
        // --- SUCCESSFUL LOGIN LOGIC ---
        const studentEmailToPass = data.email || (isEmail ? identifier : null);
        const newSessionToken = data.H7Z4L9VD2XK5JW8QRYT6 || data.session_token || `temp_token_${Math.random().toString(36).substring(2, 15)}`;

        login(
          data.student_id,
          data.first_name,
          studentEmailToPass,
          newSessionToken, 
          data.college_id,
          data.enrollment_id,
          data.academic_course 
        );

        toast.success(data.message || "Login successful!");

        if (data.college_id === null) {
          navigate("/", { replace: true });
        } else if (data.enrollment_id && data.enrollment_id > 0) {
          navigate("/", { replace: true });
        } else {
          navigate("/student-panel/category-selection", { replace: true });
        }
      } else {
        // --- FAILED LOGIN / VERIFICATION NEEDED ---
        
        if (data.is_otp_verification === 0) {
            
          // 1. GET THE OTP (from backend)
          const backendOtp = data.otp;

          // 2. GET THE MOBILE NUMBER
          // Priority 1: Backend response (data.mobile_number)
          // Priority 2: User input (identifier) IF it is a mobile number
          let targetMobile = data.mobile_number;

          if (!targetMobile && isMobile) {
              targetMobile = identifier;
          }

          // 3. SEND SMS
          if (targetMobile && backendOtp) {
            console.log(`Sending SMS to ${targetMobile} with OTP ${backendOtp}`);
            
            await sendSmsOtp(targetMobile, backendOtp);
            
            toast.info("Account unverified. OTP sent to your mobile.");
            
            // Store for the OTP page
            sessionStorage.setItem(
              "student_temp_verification_data",
              JSON.stringify({ mobile_number: targetMobile })
            );

            setTimeout(() => {
              navigate("/student-otp", { replace: true });
            }, 1500);

          } else {
            // Case: User logged in with Email, Backend didn't send mobile, and Account is unverified
            console.warn("Cannot send SMS: Mobile number missing.");
            toast.warning("Account not verified. Please check your email for OTP.");
            
            sessionStorage.setItem(
                "student_temp_verification_data",
                JSON.stringify({ mobile_number: "" }) // Allow entry to OTP page manually
            );
             setTimeout(() => {
              navigate("/student-otp", { replace: true });
            }, 1500);
          }

        } else {
          toast.error(data.message || "Invalid credentials");
        }
      }
    } catch (error) {
      console.error("Student login error:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full bg-white flex items-center justify-center">
              <button
          onClick={() => window.history.back()}
          className="fixed top-10 left-4 z-50 flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all border border-gray-200 dark:bg-gray-800 dark:border-gray-700 "
          aria-label="Go back"
        >
          <FaArrowLeft className="text-2xl text-[#103b6b] dark:text-white" />
        </button>
      <div className="w-full max-w-7xl min-h-[650px] flex flex-col md:flex-row rounded-3xl overflow-hidden shadow-lg">
        {/* Left Side */}
        <div className="w-full md:w-1/2 relative h-64 md:h-auto">
          <img
            src={loginbg}
            alt="Student Background"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30" />
          <div className="relative z-10 flex items-center justify-center h-full">
            <div
              onClick={() => navigate("/", { replace: true })}
              className="cursor-pointer transition-transform duration-200 hover:scale-105"
              title="Go to Home"
            >
              <img src={logo} alt="Logo" className="w-64" />
            </div>
          </div>
        </div>

        {/* Right Side - Form */}
        <div className="w-full md:w-1/2 bg-white flex items-start justify-center pt-6 px-6 md:px-10">
          <div className="w-full max-w-md">
            <div className="flex items-center mb-6 ml-0 md:ml-[-10%]">
              <FaUserCircle className="text-blue-900 text-[28px] md:text-[32px] mr-3" />
              <span className="text-[18px] md:text-[22px] font-semibold text-blue-900 font-inter">
                STUDENT PORTAL
              </span>
            </div>

            <h2 className="text-[40px] md:text-[55px] font-bold text-blue-900 mb-6 text-center font-inter">
              Welcome !
            </h2>

            <form className="space-y-6" onSubmit={handleSubmit}>
              {/* Email/Mobile Input */}
              <div>
                <label
                  htmlFor="identifier"
                  className="block text-sm font-medium text-gray-700 font-inter mb-1"
                >
                  Email
                </label>

                <div className="relative">
                  <input
                    type="text"
                    id="identifier"
                    name="identifier"
                    value={formData.identifier}
                    onChange={handleChange}
                    placeholder="Enter your email or mobile"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pl-10 bg-white text-gray-900"
                    required
                    disabled={isLoading}
                  />
                  <MdEmail className="absolute left-3 top-2/4 transform -translate-y-1/2 text-gray-400 text-xl" />
                </div>
              </div>

              {/* Password */}
              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-700 font-inter mb-1"
                >
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    placeholder="Enter your password"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pl-10 pr-10 bg-white text-gray-900"
                    required
                    disabled={isLoading}
                  />
                  <RiLockPasswordFill className="absolute left-3 top-2/4 transform -translate-y-1/2 text-gray-400 text-xl" />

                  <div
                    className="absolute right-3 top-2/4 transform -translate-y-1/2 text-gray-500 cursor-pointer hover:text-gray-700"
                    onClick={() => setShowPassword((prev) => !prev)}
                    tabIndex={-1}
                  >
                    {showPassword ? (
                      <AiOutlineEyeInvisible />
                    ) : (
                      <AiOutlineEye />
                    )}
                  </div>
                </div>

                {/* Forgot Password Link */}
                <div className="flex justify-end mt-1">
                  <button
                    type="button"
                    onClick={() => navigate("/student-verification")}
                    className="text-sm text-blue-900 hover:underline font-inter"
                  >
                    Forgot Password?
                  </button>
                </div>
              </div>

              {/* Submit */}
              <button
                type="submit"
                className="w-full py-3 bg-blue-900 hover:bg-blue-800 text-white font-semibold rounded-lg shadow-md transition duration-200 font-inter disabled:opacity-50"
                disabled={isLoading}
              >
                {isLoading ? "Processing..." : "Login"}
              </button>
            </form>

            <p className="mt-6 text-sm text-center text-gray-600 font-inter mb-[5%]">
              Not a member?{" "}
              <a
                href="/student-create"
                className="text-blue-900 font-medium hover:underline font-inter"
              >
                Sign up
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentLogin;